import { FC } from 'react';
import { motion } from 'framer-motion';

import { Loader } from './Loader';
import styles from './Loader.module.css';

export const FullPageLoader: FC = () => (
	<div className={styles.loader__overlay}>
		<motion.div
			className={styles[`loader__container--full-page`]}
			transition={{ duration: 0.2, easings: `easeInOut` }}
			initial={{ opacity: 1, transform: `scale(1.2)` }}
			animate={{ opacity: 1, transform: `scale(1)` }}
			exit={{ opacity: 0, transform: `scale(1.2)` }}
		>
			<Loader />
		</motion.div>
	</div>
);
